import { ApiClient } from '../../core/api/ApiClient';
import LogUtil from '../../core/utils/LogUtil';
import { CouponRepositoryImpl } from './implementations';
import { CouponService } from './services';

// Coupon Domain Exports
export * from './implementations';
export * from './interfaces';
export * from './services';

/**
 * Coupon Domain Dependency Injection Container
 * 의존성 주입을 통한 클린 아키텍처 구현
 */
class CouponDomainContainer {
  constructor() {
    this._apiClient = null;
    this._couponRepository = null;
    this._couponService = null;
  }

  get apiClient() {
    if (!this._apiClient) {
      const baseURL =
        import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1';
      this._apiClient = new ApiClient(baseURL);
      LogUtil.log('🔧 [Coupon Container] ApiClient 초기화 완료:', baseURL);
    }
    return this._apiClient;
  }

  get couponRepository() {
    if (!this._couponRepository) {
      this._couponRepository = new CouponRepositoryImpl(this.apiClient);
      LogUtil.log('🔧 [Coupon Container] CouponRepositoryImpl 초기화 완료');
    }
    return this._couponRepository;
  }

  get couponService() {
    if (!this._couponService) {
      this._couponService = new CouponService(this.couponRepository);
      LogUtil.log('🔧 [Coupon Container] CouponService 초기화 완료');
    }
    return this._couponService;
  }

  /**
   * 컨테이너 초기화 (테스트용)
   */
  reset() {
    this._apiClient = null;
    this._couponRepository = null;
    this._couponService = null;
  }
}

// Singleton 인스턴스
const container = new CouponDomainContainer();

/**
 * Coupon Service 싱글톤 접근자
 * @returns CouponService 인스턴스
 */
export const getCouponService = () => container.couponService;

/**
 * Coupon Repository 싱글톤 접근자 (테스트용)
 * @returns CouponRepositoryImpl 인스턴스
 */
export const getCouponRepository = () => container.couponRepository;

/**
 * 컨테이너 리셋 (테스트용)
 */
export const resetCouponContainer = () => container.reset();
